import { AxiosError } from 'axios'
import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'

export function validateService(reflinkUuid: string, phoneNumber?: string, email?: string) {
   let errMessage = ''
   return httpClient
      .post(
         `/client-carts/reflinks/${reflinkUuid}/verification-codes`,
         email
            ? {
                 email,
              }
            : { phoneNumber }
      )
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK validatePhoneNumber service', errMessage, 'error')
         throw error
      })
}
